import {
    escapePrintViewText,
    normalizeInlineHtml,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const buildSelectAllThatApplyQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const possibleAnswersHtml = (content.possible_answers || [])
        .map((answer) => {
            const option = escapePrintViewText(answer.option || '')
            const value = normalizeInlineHtml(replaceMediaLikeTagsWithIds(answer.value || ''))

            if (!option && !value) {
                return ''
            }

            return `<p>${option}. ${value}</p>`
        })
        .filter(Boolean)
        .join('')
    const selectedAnswers = (content.answers || [])
        .map((answer) => escapePrintViewText(answer))
        .filter(Boolean)
    const selectedAnswersHtml = selectedAnswers.length
        ? `<p>&nbsp;</p><p>Selected Answers:</p>${selectedAnswers.map((answer) => `<p>${answer}</p>`).join('')}`
        : ''
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''

    return `${questionSectionHtml}${possibleAnswersHtml}${selectedAnswersHtml}`
}

export {buildSelectAllThatApplyQuestionPrintView}
